import { PortalButtonList } from '../button-list';

export class BusinessProcessButton extends PortalButtonList {
  name = 'Business Process'
}